import { Operation } from '@/manager/sync/operation.model';
import { OperationTypeInterface } from '@/manager/sync/operationType.interface';
import { KPIInterface } from '@/manager/sync/kpi.interface';

export interface State {
    list: Operation[];
    kpiList: KPIInterface;
    operationTypeList: OperationTypeInterface[];
}

export const state: State = {
    list: [],
    kpiList: { totalIncome: 0, totalExpense: 0, operations: [] },
    operationTypeList: [],
};
